export default __webpack_public_path__ + "static/media/769.56e5a9a6.gif";